import { eraseCookie } from '../lib/cookies'

export default function previewInit() {
  $('#exit-preview').click(() => {
    eraseCookie('WMORG_PREVIEW')
    window.location = window.location.toString()
      .replace(window.location.search, '') as any
  })
}
